<template>
  <div class="verify-form">
    <div style="font-size: 24px; color: #333333; margin-bottom: 30px">
      绑定手机
    </div>
    <form @submit.prevent="handleSubmit" v-if="!userInfo?.phone || isTrue">
      <!-- 手机号输入框 -->
      <div class="form-group">
        <label for="phone">手机号：</label>
        <input
          type="tel"
          id="phone"
          v-model="form.phone"
          placeholder="请输入手机号"
          @blur="validatePhone"
          :class="{ error: formErrors.phone }"
        />
        <span class="error-message">{{ formErrors.phone }}</span>
      </div>

      <!-- 图形验证码 -->
      <div class="form-group">
        <label for="graphCode">图形验证码：</label>
        <div class="code-input-group">
          <input
            type="text"
            id="graphCode"
            v-model="form.graphCode"
            placeholder="请输入图形验证码"
            @blur="validateGraphCode"
            :class="{ error: formErrors.graphCode }"
          />
          <div class="graph-code-img" @click="refreshGraphCode">
            <img
              :src="graphCodeUrl"
              alt="图形验证码"
              @error="refreshGraphCode"
            />
          </div>
        </div>
        <span class="error-message">{{ formErrors.graphCode }}</span>
      </div>

      <!-- 手机验证码 -->
      <div class="form-group">
        <label for="smsCode">手机验证码：</label>
        <div class="code-input-group">
          <input
            type="text"
            id="smsCode"
            v-model="form.smsCode"
            placeholder="请输入手机验证码"
            @blur="validateSmsCode"
            :class="{ error: formErrors.smsCode }"
            :disabled="isSending"
          />
          <button
            type="button"
            class="send-code-btn"
            @click="validAccount"
            :disabled="isSending || !canSendCode"
          >
            {{ isSending ? `${countdown}s后重新发送` : "发送动态验证码" }}
          </button>
        </div>
        <span class="error-message">{{ formErrors.smsCode }}</span>
      </div>

      <div class="form-group submit-group">
        <label>&nbsp;</label>
        <!-- 占位label保持对齐 -->
        <button type="submit" class="submit-btn" @click="handleSubmit">
          提交
        </button>
      </div>
    </form>
    <div v-else>
      <div class="bindPhone">
        <div>
          <img
            src="@/assets/img/personal/sjbd.png"
            style="width: 80px"
            alt=""
          />
        </div>
        <div>
          <div>已绑定手机</div>
          <div style="font-size: 16px; font-weight: bold">
            {{ phoneText }}
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <button type="primary" class="submit-btn" @click="changePhone">
          更换手机号
        </button>
        <button type="" class="putong-btn" @click="clearPhone">
          解绑手机号
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
export default {
  data() {
    return {
      form: {
        phone: "",
        graphCode: "",
        smsCode: "",
      },
      formErrors: {
        phone: "",
        graphCode: "",
        smsCode: "",
      },
      graphCodeUrl: "", // 图形验证码图片地址
      isSending: false, // 是否正在发送验证码
      countdown: 60, // 倒计时秒数
      timer: null, // 倒计时计时器
      userInfo: {},
      isTrue: false,
      phoneText: "",
    };
  },
  computed: {
    // 判断是否可以发送验证码（手机号和图形验证码都有效）
    canSendCode() {
      return (
        this.form.phone &&
        this.form.graphCode &&
        !this.formErrors.phone &&
        !this.formErrors.graphCode
      );
    },
  },
  created() {
    // 初始化图形验证码
    this.refreshGraphCode();
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.phoneText = this.userInfo.phone;
  },
  beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    validAccount() {
      console.log(this.form);
      request({
        url: `/api/user/contact/valid`,
        method: "post",
        data: {
          phone: this.form.phone,
          way: "phone",
          validateCode: this.form.graphCode,
        },
      })
        .then((res) => {
          // this.isTrue = true;
          this.sendSmsCode();
        })
        .catch((error) => {});
    },
    sendCode() {
      request({
        url: `/api/auth/retrieve/captcha`,
        method: "post",
        data: {
          way: "手机",
        },
      })
        .then((res) => {
          // this.isTrue = true;
        })
        .catch((error) => {});
    },
    clearPhone() {
      // request({
      //   url: `/api/user/contact/clear?way=phone`,
      //   method: "get",
      // })
      //   .then((res) => {
      //     this.isTrue = true;
      //   })
      //   .catch((error) => {});
      if (this.userInfo.userType == "教职工") {
        this.$message.warning("请联系人事处修改");
      } else if (this.userInfo.userType == "学生") {
        this.$message.warning("请在学工系统修改");
      }
    },
    changePhone() {
      if (this.userInfo.userType == "教职工") {
        this.$message.warning("请联系人事处修改");
      } else if (this.userInfo.userType == "学生") {
        this.$message.warning("请在学工系统修改");
      }
      // this.isTrue = true;
    },
    // 刷新图形验证码
    refreshGraphCode() {
      // // 实际项目中这里应该是后端接口，添加随机数防止缓存
      // this.graphCodeUrl = `/api/captcha?random=${Math.random()}`
      // // 这里使用占位图示例，实际项目中替换为真实接口
      // if (process.env.NODE_ENV === 'development') {
      //   this.graphCodeUrl = `https://picsum.photos/100/40?random=${Math.random()}`
      // }
      request("/api/auth/captcha/img", { responseType: "blob" })
        .then((res) => {
          this.graphCodeUrl = URL.createObjectURL(res);
        })
        .catch((error) => {});
    },

    // 发送手机验证码
    sendSmsCode() {
      // 再次验证表单
      const isPhoneValid = this.validatePhone();
      const isGraphCodeValid = this.validateGraphCode();

      if (!isPhoneValid || !isGraphCodeValid) {
        return;
      }

      this.isSending = true;

      // 模拟发送验证码请求
      setTimeout(() => {
        // 实际项目中这里是后端接口调用
        this.sendCode();

        console.log("发送验证码到:", this.form.phone);
        console.log("图形验证码:", this.form.graphCode);

        // 启动倒计时
        this.startCountdown();
      }, 1000);
    },

    // 启动倒计时
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isSending = false;
          this.timer = null;
        }
      }, 1000);
    },

    // 验证手机号
    validatePhone() {
      const phone = this.form.phone.trim();
      const phoneReg = /^1[3-9]\d{9}$/;

      if (!phone) {
        this.formErrors.phone = "请输入手机号";
        return false;
      } else if (!phoneReg.test(phone)) {
        this.formErrors.phone = "请输入正确的手机号格式";
        return false;
      } else {
        this.formErrors.phone = "";
        return true;
      }
    },

    // 验证图形验证码
    validateGraphCode() {
      const graphCode = this.form.graphCode.trim();

      if (!graphCode) {
        this.formErrors.graphCode = "请输入图形验证码";
        return false;
      } else if (graphCode.length < 4) {
        // 假设图形验证码是4位
        this.formErrors.graphCode = "图形验证码格式不正确";
        return false;
      } else {
        this.formErrors.graphCode = "";
        return true;
      }
    },

    // 验证手机验证码
    validateSmsCode() {
      const smsCode = this.form.smsCode.trim();

      if (!smsCode) {
        this.formErrors.smsCode = "请输入手机验证码";
        return false;
      } else if (smsCode.length < 6) {
        // 假设手机验证码是6位
        this.formErrors.smsCode = "手机验证码格式不正确";
        return false;
      } else {
        this.formErrors.smsCode = "";
        return true;
      }
    },

    // 整体表单验证
    validateForm() {
      const isPhoneValid = this.validatePhone();
      const isGraphCodeValid = this.validateGraphCode();
      const isSmsCodeValid = this.validateSmsCode();

      return isPhoneValid && isGraphCodeValid && isSmsCodeValid;
    },

    // 提交表单
    handleSubmit() {
      console.log(this.validateForm());
      if (this.validateForm()) {
        // 表单验证通过，提交数据
        request({
          url: `/api/user/contact/bind`,
          method: "post",
          data: {
            way: "phone",
            validateCode: this.form.smsCode,
          },
        })
          .then((res) => {
            this.isTrue = true;
            this.phoneText = this.form.phone;
          })
          .catch((error) => {});
        console.log("表单提交:", this.form);
        alert("表单提交成功！");
      }
    },
  },
};
</script>

<style scoped>
.bindPhone {
  background: #f6f8fc;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.verify-form {
  max-width: 500px;
  padding: 20px; /* 只保留上下内边距 */
  height: 600px;
}

h3 {
  color: #333;
  margin: 0 0 20px 0; /* 移除居中，只保留底部间距 */
  font-size: 18px;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

label {
  width: 100px;
  text-align: right;
  margin-right: 15px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0; /* 防止label被压缩 */
}

input {
  flex-grow: 1; /* 输入框占剩余空间 */
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

input.error {
  border-color: #ff4d4f;
}

.error-message {
  display: block;
  margin-top: 5px;
  margin-left: 115px; /* 与label+间距宽度一致，保持对齐 */
  color: #ff4d4f;
  font-size: 12px;
  height: 16px;
}

.code-input-group {
  display: flex;
  gap: 10px;
  flex-grow: 1; /* 让整个输入组占满剩余空间 */
}

.graph-code-img {
  width: 100px;
  height: 42px;
  cursor: pointer;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.graph-code-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.send-code-btn {
  min-width: 120px;
  padding: 0 10px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  height: 42px; /* 与输入框高度一致 */
}

.send-code-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.submit-btn {
  padding: 10px 20px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.submit-btn:hover {
  background-color: #096dd9;
}
.putong-btn {
  padding: 10px 20px;
  background-color: #ffffff;
  color: black;
  border: 1px solid #b8ccf8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 20px;
}

.putongt-btn:hover {
  background-color: #ffffff;
}
</style>